import { kioskApi } from '../axios.js';
// Normalize cue URLs returned by the kiosk server so frontends served over HTTPS
// won't attempt to fetch dev-local (http://localhost:...) URLs saved earlier.
function normalizeCueUrl(url) {
    if (!url || typeof url !== 'string')
        return url;
    try {
        const uploadsPath = '/uploads/voice-cues/';
        const idx = url.indexOf(uploadsPath);
        // If URL contains the uploads path and we're in a browser, rewrite to the
        // current origin + path so the asset is requested from the same host/origin
        // that served the kiosk UI (works for proxied production deployments).
        if (idx !== -1 && typeof window !== 'undefined' && window.location?.origin) {
            return window.location.origin + url.substring(idx);
        }
    }
    catch (e) {
        // noop - if rewriting fails, return the original URL
    }
    return url;
}
export const voiceProfilesApi = {
    listProfiles() {
        // GET /voice-profiles
        return kioskApi.get('/voice-profiles').then((res) => {
            // Normalize any cue URLs inside each profile
            const data = Array.isArray(res.data)
                ? res.data.map((p) => ({
                    ...p,
                    cues: (p.cues || {})
                        ? Object.fromEntries(Object.entries(p.cues).map(([k, v]) => [k, normalizeCueUrl(v)]))
                        : {}
                }))
                : [];
            return { ...res, data };
        });
    },
    createProfile(payload) {
        // POST /voice-profiles
        return kioskApi.post('/voice-profiles', payload);
    },
    getProfile(profileId) {
        // GET /voice-profiles/:id
        return kioskApi.get(`/voice-profiles/${encodeURIComponent(profileId)}`).then((res) => {
            if (res.data && res.data.cues) {
                const cues = Object.fromEntries(Object.entries(res.data.cues).map(([k, v]) => [k, normalizeCueUrl(v)]));
                return { ...res, data: { ...res.data, cues } };
            }
            return res;
        });
    },
    getCues(profileId) {
        // GET /voice-profiles/:id/cues -> { key: url }
        return kioskApi.get(`/voice-profiles/${encodeURIComponent(profileId)}/cues`).then((res) => {
            const map = res.data || {};
            const transformed = Object.fromEntries(Object.entries(map).map(([k, v]) => [k, normalizeCueUrl(v)]));
            return { ...res, data: transformed };
        });
    },
    upsertCue(profileId, key, file) {
        // POST /voice-profiles/:id/cues/:key (multipart)
        const form = new FormData();
        form.append('file', file, `${key}.webm`);
        return kioskApi
            .post(`/voice-profiles/${encodeURIComponent(profileId)}/cues/${encodeURIComponent(key)}`, form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((res) => {
            const url = res.data?.url;
            return { ...res, data: { ...res.data, url: normalizeCueUrl(url) } };
        });
    },
    deleteCue(profileId, key) {
        // DELETE /voice-profiles/:id/cues/:key
        return kioskApi.delete(`/voice-profiles/${encodeURIComponent(profileId)}/cues/${encodeURIComponent(key)}`);
    }
};
